export default {
  /*
   * clientMediaInfo() devuelve información de los medios del usuario
   */
  clientMediaInfo(params, skipLoading = false) {
    // console.trace("Full client information recovered from API")
    return Vue.http.get('api_clients/client_media_info', {params, skipLoading}).then(
      response => response.data
    )
  },
  /**
   * Gets the authenticated users media types.
   * @returns {Array} Array users media types
   */
  mediaTypes(params, skipLoading = true) {
    return Vue.http.get('billing/media_types', {params, skipLoading}).then(
      response => response.data.data
    )
  },
  /*
   * existsAccount() comprueba si existe una cuenta
   */
  existsAccount(params) {
    return Vue.http.get('api_clients/exists_account', {params}).then(response => response.data.data)
  },
  /*
   * getClient() obtiene los datos de un cliente de everilion
   */
  getClient(params) {
    return Vue.http.get('api_clients/get_client', {params}).then(response => response.data.data)
  },
  /*
   * registerClient() registra un cliente en Everilion
   */
  registerClient(params) {
    return Vue.http.post('api_clients/register_client', params).then(response => response.data.data)
  },
  /*
   * validateClientTSC() valida la TSC de un usuario
   */
  validateClientTSC(params) {
    return Vue.http.post('api_clients/validate_client_tsc', params).then(
      response => response.data.data
    )
  },
  /*
   * clientAccount() obtiene los datos de la cuenta del usuario
   */
  clientAccount(params) {
    return Vue.http.get('api_clients/client_account', {params}).then(response => response.data.data)
  },
  /*
   * updateClient() actualiza los datos de la cuenta del usuario
   */
  updateClient(params) {
    return Vue.http.post('api_clients/update_client', params).then(
      response => response.data
    )
  },
  /*
   * getClientTransactions() devuelve una lista de las transacciones del usuario
   */
  getClientTransactions(params) {
    return Vue.http.get('api_clients/client_transactions', {params}).then(
      response => response.data.data
    )
  },
  /*
   *  unsuscribeQr() Desactivación del QR
   */
  unsuscribeQr(params, skipLoading = false) {
    return Vue.http.get('api_clients/unsuscribe_qr', {params, skipLoading}).then(
      response => response.data.data
    )
  },
  /*
   *    createClientCode() Crear client code
   */
  createClientCode() {
    return Vue.http.post('api_clients/create_client_code', {}).then(
      response => response.data.data
    )
  },
  getTitleByProfile(mediaProfile,administrativeAreaId){
    const params = {
      media_profile_id:mediaProfile,
      administrative_area_id:administrativeAreaId,
    }

    return Vue.http.get('ticketing/titles/default_for_client_registration', {params}).then(
      response => response.data.data
    )
  },
  getApiKey(){
    const fullUrl = Vue.store.getters['runtimeConfig/apiSuportData'] + 'v1/token/generate-apikey';
    return Vue.http.get(fullUrl)
      .then(
        response => response.body
      );
  },
  /*
   *    createClientCode() Crear client code
   */
  createToken(data, queryParams, apiKey) {
  const endpoint = 'v1/token/data'; 
  const fullUrl = `${Vue.store.getters['runtimeConfig/apiSuportData']}/${endpoint}`;
  
  const customHeaders = {
    'x-api-key': Vue.store.getters['runtimeConfig/apiKey'] 
  };

  return Vue.http.post(fullUrl, data, { params: queryParams, headers: customHeaders })
    .then(
      response => response.body
    );
}
}
